import React from 'react';

import { Header } from '@sravni/react-header';

import { useSelectHeaderSettings } from '@src/reducers/siteSettings';

import { useMakeLogoNotInteractive } from '../lib';

export const KazakhstanPageHeader = () => {
  const headerSettings = useSelectHeaderSettings();

  const headerRef = useMakeLogoNotInteractive();

  return <Header ref={headerRef} settings={headerSettings} mode="landing" enableTheme search={null} />;
};
